module.exports = __webpack_public_path__ + "img/arrow-pin-xsmall.e7c03023.png";